import React from "react";
import { useTranslation } from "react-i18next";
import { DrumIcon, VenuesIcon } from "../ui/icons";

const MapLegend: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="absolute bottom-12 md:bottom-20 left-4 md:left-6 z-[1000] pointer-events-none">
      <div className="bg-[#2F0D68E5] backdrop-blur-md border-modal rounded-[16px] p-4 md:shadow-[0_12px_40px_rgba(0,0,0,0.5)] flex flex-col gap-4 min-w-[200px]">
        {/* Gear Legend */}
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-full bg-primary flex items-center justify-center shadow-[0_0_15px_rgba(90,24,196,0.3)]">
            <DrumIcon size={16} color="white" />
          </div>
          <span className="text-white font-medium text-[14px] tracking-tight">
            {t("map.gearAvailable", "Gear Available")}
          </span>
        </div>

        {/* Venue Legend */}
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-full bg-secondary flex items-center justify-center shadow-[0_0_15px_rgba(255,124,103,0.3)]">
            <VenuesIcon size={16} color="white" />
          </div>
          <span className="text-white font-medium text-[14px] tracking-tight">
            {t("map.venueAvailable", "Venue Available")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MapLegend;
